import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { ParcelTrackerRoleEnum } from "src/app/shared/generated/enum/parcel-tracker-role-enum";

@Injectable({ providedIn: "root" })
export class ParcelTrackerPowerAccessGuard implements CanActivate {
    constructor(private authenticationService: AuthenticationService, private router: Router) {}

    canActivate(): Observable<boolean> {
        return this.authenticationService.getCurrentUser().pipe(
            take(1),
            map((user) => {
                const role = user?.ParcelTrackerRoleID;
                const allowed = role === ParcelTrackerRoleEnum.Admin || role === ParcelTrackerRoleEnum.Power;
                if (!allowed) {
                    this.router.navigate(["/moorings/inventory"]);
                    return false;
                }
                return true;
            }),
        );
    }
}
